<script lang="ts">
    import { onMount } from "svelte"
    import { fade } from "svelte/transition"

    // https://www.besucherzaehler-kostenlos.de/webcounter/

    $: counterHTML = null

    onMount(() => {
        setTimeout(() => {
            let vc = document.getElementById("visitor-counter")
            counterHTML = vc.innerHTML
            // vc.remove() // Element muss auf Seite immer vorhanden bleiben (daher kein remove), da Svelte sonst bei Template-Updates keinen Zugriff mehr auf den vorgerenderten Kontainer hat
        }, 100)
    })
</script>

<h3>Besucherzähler</h3>

{#if counterHTML}
    <div transition:fade>
        {@html counterHTML}
    </div>
{/if}
